import { Slider } from 'components/molecules/Slider'
import { Section } from 'components/organisms/Section'
import type { TestimonialsProps } from './types'
import { Button, EButtonVariant } from 'components/atoms/Button'

import './index.scss'

const mainClass = 'testimonials'

export const Testimonials = ({
  title,
  subtitle,
  note,
  action,
  list = [],
}: TestimonialsProps) => {
  if (!list.length) {
    return null
  }

  return (
    <Section
      id="_testimonials"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      <Slider variableWidth className={`${mainClass}__slider`}>
        {list.map((item) => (
          <div key={item.id} className={`${mainClass}__card`}>
            <p className={`${mainClass}__text`}>{item.text}</p>
            {/* <footer className={`${mainClass}__footer`}>
              {item.link.href ? (
                <Button
                  href={item.link.href}
                  variant={EButtonVariant.LINK}
                  className={`${mainClass}__link`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.link.text}
                </Button>
              ) : (
                item.link.text
              )}
            </footer> */}
          </div>
        ))}
      </Slider>
    </Section>
  )
}
